<template>
  <div class="imageBox">
    <div style="display: flex; align-items: center; flex-direction: column;margin-bottom :2rem;padding-top: 30px;">
      <div :style="`width: ${width}px; height: 248px; background-color: #353535; border-radius: 24px;display: flex;flex-direction: column; align-items: flex-start; padding: ${padding}; justify-content: space-between;position: relative;overflow:hidden;`">
        <div style="font-size: 38px; color: #fff; line-height: 38px;">{{'PowerFun 设置'}}</div>
        <div style="font-size: 24px; color: rgba(255,255,255,0.70);">{{store.state.language == 'cn' ? '用于PowerFun功率计固件OTA':"Used for PowerFun power meter firmware OTA"}}</div>
        <div style="display: flex; align-items: center;z-index: 1;">
          <a href="https://powerfun.oss-cn-shanghai.aliyuncs.com/yecongdfu/apks/powerfun_setting.apk" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;" target="_blank">Android</a>
          <a href="https://apps.apple.com/cn/app/powerfun%E8%AE%BE%E7%BD%AE/id6756413469" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;margin-left: 14px;" target="_blank">iOS</a>
          <!-- <a href="https://appgallery.huawei.com/app/detail?id=com.ZhiXingPai.PowerFunRower&channelId=SHARE" style="height: 42px; display: flex; align-items: center; justify-content: center; padding: 0 12px; color: #fff;border-radius: 8px; background-color: #e63422;font-size: 24px;line-height: 24px;margin-left: 14px;" target="_blank">鸿蒙</a> -->
        </div>
        <img src="../assets/download/Settings-1.png" style="position: absolute; right: 0; top: 0; width: 400px; height: 248px;z-index: 0;">
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
const store = useStore();

const width = ref(1200)
const padding = ref('30px 34px')

const handleResize = () => {
  const clientWidth = document.documentElement.clientWidth
  console.log(clientWidth)
  if(clientWidth < 1200){
    width.value = clientWidth -20
    padding.value = '20px'
  }else{
    width.value = 1200
    padding.value = '30px 34px'
  }
}
onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize);
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
})
// function IOSDownload() {
//   //window.location.href = "https://itunes.apple.com/cn/app/id1411875128?mt=8";
//   //showToast('APP即将上架，敬请期待');
//   console.log(44);
//   window.location.href =
//     "https://apps.apple.com/us/app/%E8%88%B9%E9%81%93/id6444202305";
// }
// function OssDownload() {
//   window.location.href =
//     "https://powerfun.oss-cn-shanghai.aliyuncs.com/apks/PowerFunRower.release.apk";
// }
</script>
<!-- getImagePath('软件图片.png') -->
<style lang="scss" scoped>
.imageBox {
  min-height: calc(100vh - 12.125rem);
  width: 100%;
}

a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的颜色 */
}

a,a *{
  user-select: none; /* 禁止选中 */
  pointer-events: all; /* 确保链接仍然可点击 */
  cursor: pointer;
}

div{
  box-sizing: border-box;
}
</style>
